import { render, staticRenderFns } from "./MappingsReadOnlyPanel.vue?vue&type=template&id=36d55162"
import script from "./MappingsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./MappingsReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports